import React from 'react'
import { FibaInputNumber, Form } from '../../components'
import { Field } from '@progress/kendo-react-form'

const SettingsDetail = () => {
    return (
        <div className="mx-auto font-semibold max-w-7xl">
            <Form
                initialValues={{ is_public: 0 }}
                detail={'ml000031'}
                read={'ml000032'}
                id={1}
            >
                <div className="grid gap-4 mt-2 md:grid-cols-2 sm:grid-cols-1">
                    <Field
                        name={'shippingamount'}
                        component={FibaInputNumber}
                        label={"Хүргэлтийн дүн"}
                    />
                </div>

            </Form>

        </div>
    )
}

export default SettingsDetail